import { inject, Injectable, NgZone } from "@angular/core";
import { UserStore } from "../stores/user.store";
import { UserRepresentsStore } from "../stores/user-represents.store";
import { Router } from "@angular/router";
import { User } from "../models/user.model";

@Injectable({ providedIn: "root" })
export class TestService {
  private userStore = inject(UserStore);
  private userRepresentsStore = inject(UserRepresentsStore);
  private router = inject(Router);
  private ngZone = inject(NgZone);

  private static get cypress(): any {
    return window["Cypress"];
  }

  private static env<T = string>(key: string): T {
    return TestService.cypress?.env(key);
  }

  private static get disableKeycloak(): boolean {
    return TestService.env<boolean>("disableKeycloak");
  }

  public static get isRunningInTestContext(): boolean {
    return !!TestService.cypress;
  }

  public static get isRunningInFrontendTestContext(): boolean {
    return TestService.disableKeycloak && !TestService.refreshToken && !TestService.accessToken;
  }

  public static get isRunningInE2eTestContext(): boolean {
    return !TestService.disableKeycloak && !!TestService.refreshToken && !!TestService.accessToken;
  }

  public static get idToken(): string | User {
    return TestService.cypress?.hbKeycloakIdToken;
  }

  public static get accessToken(): string {
    return TestService.cypress?.hbKeycloakAccessToken;
  }

  public static get refreshToken(): string {
    return TestService.cypress?.hbKeycloakRefreshToken;
  }

  public loginFrontendTest(): void {
    const tokenParsed = TestService.idToken;

    if (typeof tokenParsed !== "object") {
      throw new Error("window.Cypress.hbKeycloakIdToken er ikke satt korrekt!");
    }

    this.userStore.update(tokenParsed);
    this.userRepresentsStore.add({ organisasjonsnavn: tokenParsed.organization_name, organisasjonsnummer: tokenParsed.organization_number });
    this.userRepresentsStore.setActive(tokenParsed.organization_number);
  }

  public checkAndEnableTestRunnerNavigation(): void {
    if (TestService.isRunningInTestContext) {
      window["cypressNavigateByUrl"] = (url: string): void => {
        this.ngZone.run(() => this.router.navigateByUrl(url));
      };
    }
  }
}
